<template>
  <div class="wl-container">
    <i class="info" v-if="whitelistRemitters.length >= maxLimit">You have reached the maximum limit for whitelisting remitters. Please contact support to increase the limit.</i>

    <div class="whitelist-remitters" :class="{'border': whitelistRemitters.length}">
      <div v-for="(remitter, index) in whitelistRemitters" :key="index"
            class="content">
        <div class="account-title">
          <p @click="toggleRemitter(index)">
            <i v-if="remitter.show" class="fa fa-angle-up" />
            <i v-else class="fa fa-angle-down" />
            Account {{index + 1}}
          </p>

          <div class="options">
            {{remitter.status}}
            <i class="fa" :class="remitter.css" />
            <i class="fa fa-trash" @click="deleteRemitter(index)" />
          </div>
        </div>

        <bank-details v-if="remitter.show" class="bank"
                      @updateAccount="updateAccount" :index="index"
                      :initialVals="remitter" />
      </div>
    </div>

    <button v-if="whitelistRemitters.length < maxLimit" class="dark-btn"
            @click="addRemitter">
      <i class="fa fa-plus" />
      Remitters
    </button>
  </div>
</template>

<script>
import BankDetails from '@/components/Bank/InputDetails'
import HyptoPopup from '@/components/global/HyptoPopup'

import { mapGetters } from 'vuex'

export default {
  name: 'AddWhitelistRemitters',
  components: { BankDetails, HyptoPopup },
  data () {
    return {
      whitelistRemitters: [],
      maxLimit: 5
    }
  },
  computed: {
    ...mapGetters(['getterSectionDetails'])
  },
  created () {
    this.$emit('setFunctions', this.remitterFunctions)
    this.maxLimit = this.getterSectionDetails.wl_limit
  },
  methods: {
    addRemitter () {
      this.whitelistRemitters.push({
        show: false,
        status: 'Not filled',
        css: 'fa-exclamation-circle'
      })
    },
    deleteRemitter (index) {
      this.whitelistRemitters.splice(index, 1)
    },
    toggleRemitter (index) {
      this.whitelistRemitters[index].show = !this.whitelistRemitters[index].show
      this.whitelistRemitters = this.whitelistRemitters.slice()
    },
    updateAccount (account, status, index) {
      if (status === 'SUCCESS') {
        this.whitelistRemitters[index] = {
          ...this.whitelistRemitters[index],
          status: 'Valid',
          css: 'fa-check-circle'
        }
      } else if (status === 'FAILED') {
        this.whitelistRemitters[index] = {
          ...this.whitelistRemitters[index],
          status: 'Invalid',
          css: 'fa-times-circle'
        }
      }
      this.whitelistRemitters[index] = {
        ...this.whitelistRemitters[index],
        number: account.number,
        ifsc: account.ifsc,
        bank: account.bank,
        error: account.error
      }
      this.whitelistRemitters = this.whitelistRemitters.slice()
      this.$emit('watchRemitters')
    },
    remitterFunctions () {
      return {
        status: this.getStatus,
        get: this.getList
      }
    },
    getStatus () {
      return this.whitelistRemitters.every(e => e.status === 'Valid') || this.whitelistRemitters.length === 0
    },
    getList () {
      return this.whitelistRemitters.map(e => {
        return {
          number: e.number,
          ifsc: e.ifsc.toUpperCase()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .wl-container {
    margin-top: 10px;

    .info {
      color: $grey-light;
      display: block;
      text-align: left;
      font-size: 12px;
      margin-bottom: 5px;
    }

    .dark-btn {
      margin: 10px 0;

      .fa {
        margin-right: 5px;
      }
    }
  }

  .whitelist-remitters {
    border-radius: 15px;

    &.border {
      border: 2px solid $grey-outline;
    }

    .content {
      text-align: left;
      border-bottom: 2px solid $grey-outline;

      &:last-child {
        border: 0;
      }

      .account-title {
        @include custom-flex(space-between);
        padding: 10px;
        border-bottom: 2px solid $grey-outline;

        &:last-child {
          border: 0;
        }

        p {
          font-weight: 500;
          font-size: 13px;
          cursor: pointer;
          i {
            margin-right: 5px;
          }
        }

        .options {
          .fa {
            margin: 0 3px;
            cursor: pointer;

            &.fa-trash, &.fa-times-circle {
              color: $error;
            }
            &.fa-check-circle {
              color: $primary;
            }
            &.fa-exclamation-circle {
              color: $grey-text;
            }
          }
        }
      }

      .bank {
        padding: 10px;
        border-radius: 5px;
        margin-top: 8px;
      }
    }
  }
</style>
